export default {
  methods: {
    scrollToTop(id) {
      document.getElementById(id).scrollIntoView({ behavior: 'smooth' });
    },
  },
};
